import Typography from "@portal/components/atoms/v2/typography";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { PlanningPageData } from "../../../components/highcharts/PlanningPageData";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { IPlanningInfoProps } from "../types";

export const PlanningInfo = ({ isDefaultLanguage }: IPlanningInfoProps) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <div className="flex flex-col mt-3 px-1">
      <Typography variant="Body">{texts.PAGE_4_INFO_TEXT_A}</Typography>
      <div className="flex my-4 border rounded-md p-1 bg-white">
        <HighchartsReact highcharts={Highcharts} options={PlanningPageData(isDefaultLanguage)} />
      </div>
      <Typography variant="Bold">{texts.PAGE_4_INFO_TEXT_B}</Typography>
      <Typography variant="Body">{texts.PAGE_4_INFO_TEXT_C}</Typography>
      <br />
      <Typography variant="Bold">{texts.PAGE_4_INFO_TEXT_D}</Typography>
      <Typography variant="Body">{texts.PAGE_4_INFO_TEXT_E}</Typography>
      <br />
      <Typography variant="Bold">{texts.PAGE_4_INFO_TEXT_F}</Typography>
      <Typography variant="Body">{texts.PAGE_4_INFO_TEXT_G}</Typography>
      <br />
      <Typography variant="Body">{texts.PAGE_4_INFO_TEXT_H}</Typography>
    </div>
  );
};
